import DOMPurify from "dompurify";

// Sanitize admin-authored HTML before rendering with dangerouslySetInnerHTML.
export function sanitizeHtml(html) {
  return DOMPurify.sanitize(html || "", { USE_PROFILES: { html: true } });
}
